import { LazyLoad } from 'app/utils';

export const DrivePage = LazyLoad(
  () => import('./index'),
  (module) => module.DrivePage,
);
